import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { L10nTranslationService } from 'angular-l10n';
import {
  getLocalStorageItem,
  remindTheirChoice,
  NICE_CONFIRM_DIALOG_KEY,
  ConfirmData,
} from './confirm-dialog-sp.const';

@Component({
  selector: 'sp-confirm-dialog',
  templateUrl: './confirm-dialog-sp.component.html',
  styleUrls: ['./confirm-dialog-sp.component.scss'],
  standalone: false,
})
export class ConfirmDialogSPComponent implements OnInit, OnDestroy {
  public showDialog = false;
  public showCloseButton = false;
  public rememberChoice = false;
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogSPComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmData,
    public translationService: L10nTranslationService
  ) {
    if (data.rememberMyChoiceDialogId) {
      const choice = remindTheirChoice(data.rememberMyChoiceDialogId);
      if (choice !== null) {
        this.selectOption(choice);
        return;
      }
    }
    this.setData(data);
  }

  ngOnInit(): void {
    // required by angular-l10n
  }

  ngOnDestroy(): void {
    // required by angular-l10n
  }

  private setData({
    message = 'commonLabels.areYouSure',
    confirmText = 'commonLabels.yes',
    cancelText = null,
    showCloseButton = false,
    rememberMyChoiceDialogId,
    doNotRemindMeText = null,
    rememberOnlyIfTrue,
    title = 'shared.alert',
  }: ConfirmData) {
    this.data = {
      message: this.translationService.translate(message),
      confirmText: this.translationService.translate(confirmText),
      cancelText: cancelText ? this.translationService.translate(cancelText) : null,
      rememberMyChoiceDialogId,
      doNotRemindMeText: doNotRemindMeText ? this.translationService.translate(doNotRemindMeText) : null,
      showCloseButton,
      rememberOnlyIfTrue,
      title: this.translationService.translate(title),
    };
    this.showDialog = true;
    this.showCloseButton = showCloseButton;
  }

  onClose() {
    this.dialogRef.close();
  }

  public selectOption(yesNo: boolean) {
    if (
      this.data.rememberMyChoiceDialogId != null &&
      this.rememberChoice &&
      (!this.data.rememberOnlyIfTrue || (this.data.rememberOnlyIfTrue && yesNo))
    ) {
      this.saveTheirChoice(this.data.rememberMyChoiceDialogId, yesNo);
    }
    this.dialogRef.close(yesNo);
  }

  private saveTheirChoice(dialogId: string, choice: boolean) {
    const confirmDialogValues = getLocalStorageItem(NICE_CONFIRM_DIALOG_KEY) || {};
    confirmDialogValues[dialogId] = choice;
    window.localStorage.setItem(NICE_CONFIRM_DIALOG_KEY, JSON.stringify(confirmDialogValues));
  }
}
